import { rem } from "@certn/cascadia";
import {
  BasicButton,
  ButtonGroup,
  LegacyModal,
  ModalContent,
  ModalFooter,
  ModalHeader,
  PrimaryButton,
  Select,
  Text,
} from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Item } from "react-stately";

import { useLanguageOptions } from "../../hooks/api/useLanguageOptions";
import { useLanguage } from "../../hooks/useLanguage";

type DeclineModalProps = {
  onClose: () => void;
};

export function LanguageModal({ onClose }: DeclineModalProps) {
  const { t, i18n } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState<string>(
    i18n.resolvedLanguage ?? i18n.language
  );
  const { languageOptions } = useLanguageOptions();
  const { changeLanguage } = useLanguage();

  return (
    <LegacyModal>
      <ModalHeader close={onClose} title={t("Language and region")} />
      <ModalContent>
        <Text style="form/body-secondary" color="text-weak">
          <Trans>
            This will change the language settings within your profile.
          </Trans>
        </Text>
        {languageOptions && (
          <div
            className={css({
              marginTop: rem("space-2"),
            })}
          >
            <Select
              selectedKey={selectedLanguage}
              name="language"
              aria-label={t("Language")}
              onSelectionChange={(key) => setSelectedLanguage(key.toString())}
            >
              {languageOptions?.map((language) => (
                <Item key={language.value}>{language.display_value}</Item>
              ))}
            </Select>
          </div>
        )}
      </ModalContent>
      <ModalFooter>
        <ButtonGroup>
          <BasicButton size="medium" onPress={onClose}>
            <Trans>Cancel</Trans>
          </BasicButton>
          <PrimaryButton
            onPress={async () => {
              await changeLanguage(selectedLanguage);
              onClose();
            }}
            size="medium"
          >
            <Trans>Save</Trans>
          </PrimaryButton>
        </ButtonGroup>
      </ModalFooter>
    </LegacyModal>
  );
}
